
import { Component, Prop, Vue } from 'nuxt-property-decorator'
import LocationIcon from '~/assets/images/icons/icon-location.svg?inline'

@Component({
  components: {
    LocationIcon,
  },
})
export default class DetectGeolocationBtn extends Vue {
  @Prop({ required: false, default: false, type: Boolean })
  private readonly border!: boolean

  @Prop({ required: false, default: 'md', type: String })
  private readonly size!: 'sm' | 'md' | 'lg'

  private isLoading = false

  get classList () {
    const base = 'detect-location'
    return [
      base,
      `${base}--${this.size}`,
      {
        [`${base}--with-border`]: this.border,
      },
    ]
  }

  get isCanDetectLocation () {
    try {
      return !!window.navigator.geolocation
    } catch (e) {
      return false
    }
  }

  async onClick () {
    try {
      this.isLoading = true
      const position = await this.detectLocation()
      this.$emit('on-located', position)
    } catch (e) {
      this.$emit('on-error', e)
    } finally {
      this.isLoading = false
    }
  }

  detectLocation () {
    return new Promise((resolve, reject) => {
      if (!this.isCanDetectLocation) {
        reject(
          new Error('Unable to detect user\'s location. Most likely, browser doesn\'t support navigator.geolocation'),
        )

        return
      }

      window.navigator.geolocation.getCurrentPosition((position) => {
        resolve({
          coords: {
            accuracy: position.coords.accuracy,
            altitude: position.coords.altitude,
            altitudeAccuracy: position.coords.altitudeAccuracy,
            heading: position.coords.heading,
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
            speed: position.coords.speed,
          },
          timestamp: position.timestamp,
        })
      }, reject, {
        enableHighAccuracy: true,
      })
    })
  }
}
